import { getPatternStyles, patternFns } from './runtime.mjs';
import { memo } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const spacerConfig = { transform(props, { map, isCssUnit, isCssVar }) {
  const { size, ...rest } = props;
  return {
    alignSelf: "stretch",
    justifySelf: "stretch",
    flex: map(size, (v) => {
      if (v == null) return "1";
      return `0 0 ${isCssUnit(v) || isCssVar(v) ? v : `token(spacing.${v}, ${v})`}`;
    }),
    ...rest
  };
} }

export function spacerRaw(styles) {
  const s = getPatternStyles(spacerConfig, styles || {})
  return spacerConfig.transform(s, patternFns)
}

export const spacer = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function spacer(styles = {}) {
  return css(spacerRaw(styles))
}), { raw: spacerRaw, propKeys: ["size"] })